import React, { Fragment, useEffect, useMemo, useState } from "react";

import ReactTable from "components/ReactTable/ReactTable.js";
import Button from "components/CustomButtons/Button.js";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { Add } from "@material-ui/icons";

import { wsGetAll, wsFindBy } from "services/WService.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
}));

const familyTableColumns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Código", accessor: "code", width: 110 },
  { Header: "Descripción", accessor: "description" },
  { Header: "Agregar", accessor: "actions", excelEnabled: false }
];

export default function Familiy(props) {
  const classes = useStyles();

  const { providers, categories } = props;
  const statePromo =
    props.promo.state == "N" || props.promo.state == "G" ? false : true;

  const [providerId, setProviderId] = useState(0);
  const [categoryId, setCategoryId] = useState(0);

  const [families, setFamilies] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  async function listFamily(provider_id = 0, category_id = 0) {
    let response;
    if (provider_id != 0 || category_id != 0) {
      let search = {};
      if (provider_id != 0) search.base_business_partner_id = provider_id;
      if (category_id != 0) search.logi_category_id = category_id;
      response = await wsFindBy('prom/promotion/group-stock/family', search);
    } else {
      response = await wsGetAll('prom/promotion/group-stock/family');
    }

    if (response.success) {
      setFamilies(response.data.families);
      setWarehouses(response.data.warehouses);
    }
  }

  useEffect(() => {
    listFamily(providerId, categoryId);
  }, [providerId, categoryId, props.promo]);

  useEffect(() => {
    setProviderId(props.promo.base_business_partner_id);
  }, [props.promo]);

  const columns = useMemo(() => {
    if(warehouses.length === 0) return familyTableColumns;

    let columns = [];
    let index = familyTableColumns.findIndex((item) => item.accessor === 'description');
    for (let i = 0; i <= index; i++) {
      columns.push(familyTableColumns[i]);
    }
    for(let warehouse of warehouses){
      columns.push({
        Header: warehouse.WhsName.replace('Almacén', ''),
        accessor: `WHS-${warehouse.id}`,
        width: 85,
      });
    }
    for (let i = index + 1; i < familyTableColumns.length; i++) {
      columns.push(familyTableColumns[i]);
    }
    return columns;
  }, [warehouses]);

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={4}>
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Proveedor</InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              value={providerId || 0}
              onChange={(e) => {
                setProviderId(e.target.value);
                props.listCategories(e.target.value);
                if (e.target.value == 0) {
                  setCategoryId(0);
                }
              }}
            >
              <MenuItem value={0}>Ninguno</MenuItem>
              {providers.map((provider, i) => {
                return (
                  <MenuItem value={provider.id} key={i}>
                    {provider.CardName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={4}>
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Categoría</InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              value={categoryId}
              disabled={providerId == 0}
              onChange={(e) => {
                setCategoryId(e.target.value);
              }}
            >
              <MenuItem value={0}>Ninguno</MenuItem>
              {categories.map((category, i) => {
                return (
                  <MenuItem value={category.id} key={i}>
                    {category.description}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem>
      </GridContainer>

      <ReactTable
        exportExcel={false}
        heightRow={50}
        columns={columns}
        data={families.map((family, i) => {
          let dataStocks = {};
          for (let stock of family.stocks) {
            dataStocks[`WHS-${stock.logi_warehouse_id}`] =
              parseFloat(stock.OnHand) - parseFloat(stock.IsCommited);
          }
          return {
            num: i + 1,
            code: family.code,
            description: family.description,
            ...dataStocks,
            actions: (
              <div className="actions-right">
                <Button
                  justIcon
                  color="success"
                  className="like"
                  size="sm"
                  round
                  onClick={() => {
                    props.addProduct(family);
                  }}
                  disabled={statePromo}
                >
                  <Add />
                </Button>
              </div>
            )
          };
        })}
      />
    </Fragment>
  );
}
